import {
  Component,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { fromStorage } from "../from-storage.function";
import { OAuthConnectionResult } from "../oauth-connection-result";

@Component({
  selector: "app-close-qb-oauth",
  templateUrl: "./close-qb-oauth.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./close-qb-oauth.component.scss"],
})
export class CloseQbOauthComponent implements OnInit {
  route = inject(ActivatedRoute);
  readonly newCompanyConnectionStatus = fromStorage<boolean>(
    "newCompanyConnectionStatus",
  );
  readonly oauthConnectionResult = fromStorage<OAuthConnectionResult>(
    "oauthConnectionResult",
  );

  constructor() {}

  ngOnInit(): void {
    const status = this.route.snapshot.queryParamMap.get("status") || "";
    const message = this.route.snapshot.queryParamMap.get("message") || "";
    console.log("Status", status);

    const isSuccess = status === "success";

    // Write the full payload first so consumers never toast on a partial update.
    this.oauthConnectionResult.set({
      success: isSuccess,
      status,
      message,
    });
    this.newCompanyConnectionStatus.set(isSuccess);
    window.opener?.postMessage(
      JSON.stringify({
        type: "quickbooks",
        status,
        message,
      }),
      "*",
    );

    // Close immediately — no UI. Parent also listens and may close this popup.
    window.close();
  }
}
